import { UnstyledButton } from '@backoffice-frontend/patterns'
import { XIcon } from '@moia-dev/pace-icons'
import type { ReactNode } from 'react'

export const MobileHeader = ({
  onClose,
  logo,
  logoVariant = 'light',
}: {
  onClose: VoidFunction
  logo: ReactNode
  logoVariant?: 'dark' | 'light'
}) => {
  return (
    <div
      css={theme => ({
        borderBottom: '1px solid var(--color-accessory-default-alternative)',
        height: 48,
        display: 'flex',
        alignItems: 'center',
        padding: theme.space.Space3,
        background:
          logoVariant === 'light'
            ? theme.semantic.ColorSurfaceDefault
            : theme.semantic.ColorBackgroundFixedDefault,
        color:
          logoVariant === 'light'
            ? theme.semantic.ColorContentDefault
            : theme.semantic.ColorContentOnBackgroundFixedDefault,
      })}
    >
      <div
        css={{
          flexGrow: 1,
          marginLeft: 24,
          textAlign: 'center',
          lineHeight: '12px',
          svg: { height: 12 },
        }}
      >
        {logo}
      </div>
      <UnstyledButton onClick={onClose} css={{ width: 24, height: 24 }}>
        <XIcon />
      </UnstyledButton>
    </div>
  )
}
